/*
* @Author: gujianghua
* @Date:   2020-05-09 14:36:12
* @Last Modified by:   gujianghua
* @Last Modified time: 2020-05-14 11:24:32
*/
import { service,BASE_API } from '@/utils/request'
import { searchParamsFormatter } from '@/api/common'
const v2 = BASE_API

export default {
	//获取列表
  	getList: (data) => {
	    return service({
	      url: '/cloud/course/v1/admin/features/findList',
	      method: 'get',
	      params: data
	    })
	},
  	//获取列表
  	getCourseTypeList: (data) => {
	    return service({
	      url: '/cloud/course/v1/admin/course/product/type/list',
	      method: 'get',
	      params: data
	    })
	},
	add(data) {
	    return service({
	      url: '/cloud/course/v1/admin/features/add',
	      method: 'post',
	      data: data
	    })		
	},
	switch(data) {
		return service({
	      url: '/cloud/course/v1/admin/features/onOff',
	      method: 'post',
	      data: data
	    })
	},
	deleteData(path) {
		return service({
	      url: '/cloud/course/v1/admin/features/del/' + path,
	      method: 'get',
	    })
	},
	getDataById(path) {
	    return service({
	      url: '/cloud/course/v1/admin/features/get/' + path,
	      method: 'get'
	    })		
	},
	updateData(data) {
		return service({
	      url: '/cloud/course/v1/admin/features/update',
	      method: 'post',
	      data: data
	    })
	}
}


// WEBPACK FOOTER //
// ./src/api/contentManage/subjectmanage.js